export default __webpack_public_path__ + "static/media/play-solid.4121b85d.svg";